import classNames from 'classnames';
import React from 'react';

import {TRANSITION_DELAY_CLASSNAME} from '../StudentHomepage';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional, PropsWithChildrenRequired {}

export default function SidebarWrapperDesktop({children, className}: Props) {
  const {isSidebarExpanded} = useStudentDashboard();

  return (
    <div
      aria-hidden={!isSidebarExpanded}
      className={classNames(className, 'hidden flex-col px-x4 pt-x7 pb-x3 m:flex', {
        'opacity-0': !isSidebarExpanded,
        [TRANSITION_DELAY_CLASSNAME]: isSidebarExpanded
      })}
    >
      {children}
    </div>
  );
}
